// extracted by mini-css-extract-plugin
export default {"container":"PersonCard_container__0BAMg","simple":"PersonCard_simple__8m0-i","content":"PersonCard_content__gv862","hide":"PersonCard_hide__c5qQx"};